<template>
  <div>
    <div>
      <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">
        <div class="row">
          <!--Created At Filter --->
          <div class="row">
            <RangeDatePicker
              id="date-filter-picker"
              v-model="filters.dateRange"
              class="col-12 col-md-4 datesFilter"
              :placeholder="$t('optometry.leads.date_range')">

              <div slot="label">
                <label class="form-label">{{ $t('statistics.daterange_created_at') }}</label>
              </div>

            </RangeDatePicker>
          </div>

          <!----->
        </div>
      </div>
      <v-server-table
        id="leadsWebFlowsTable"
        ref="leadsWebFlowsTable"
        name="leadsWebFlowsTable"
        :columns="columns"
        :options="tableOptions"
        @filter="onFilterUpdate"
        @loading="isLoading = true"
        @loaded="isLoading = false"
        @row-click="handleFlowClicked">

        <span slot="created_at" class="no-break" slot-scope="props">{{ props.row.created_at | localTime }}</span>

        <span slot="start_date" class="no-break" slot-scope="props">{{ props.row.start_date | localTime }}</span>

        <span slot="end_date" class="no-break" slot-scope="props">{{ props.row.end_date | localTime }}</span>

        <span slot="client" slot-scope="props">
            {{handleClientName(props.row)}}
        </span>

          <span slot="lang" slot-scope="props">
            {{props.row.lang.toUpperCase() || "N/A"}}
          </span>

        <span slot="country" slot-scope="props">
          {{props.row.country.toUpperCase() || "N/A"}}
        </span>


      </v-server-table>
    </div>
  </div>
</template>

<script>

import RangeDatePicker from "@/components/common/RangeDatePicker";
import TableQueryMixin from "@/mixins/TableQueryMixin";
import axios from "axios";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder";

export default {
  components: {LoadingPlaceholder, RangeDatePicker},
  mixins: [
    TableQueryMixin
  ],
  props: {
    showFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    querySearch: {
      type: String,
      required: false,
      default: null
    },
    customQueries: {
      type: Object,
      required: false,
      default: null
    }
  },
  mounted: function () {
  },
  data: function () {
    return {
      filters: {
        querySearch: '',
        dateRange: {
          start: this.moment().subtract(1, 'months').format('YYYY-MM-DD'),
          end: this.moment().format('YYYY-MM-DD'),
        }
      },
      isLoading: false,
      queryUrl: `${this.$store.state.leads_web_server}/v1/flows`,
      columns: ['created_at', 'start_date', 'end_date', 'name', 'client', 'lang', 'country'],
      tableOptions: {
        orderBy:{
          column: 'created_at',
          ascending: false
        },
        saveState: true,
        storage: 'local',
        filterable: ['created_at'],
        sortable: ['created_at'],
        customFilters: ['start', 'end'],
        columnsClasses: {
          created_at: 'createdAtClass',
        },
        headings: {
          created_at: this.$t('leads-web.table_headings.created_at'),
          start_date: this.$t('leads-web.table_headings.start_date'),
          end_date: this.$t('leads-web.table_headings.end_date'),
          name: this.$t('leads-web.table_headings.flow_name'),
          client: this.$t('leads-web.table_headings.client'),
          lang: this.$t('leads-web.table_headings.language'),
          country: this.$t('leads-web.table_headings.country'),
        }
      },
      selectedFlow: null
    }
  },
  methods: {
    onLoading: function () {
    },
    reload: function () {
      this.$refs.leadsWebFlowsTable.refresh()
    },

    handleClientName: function(flow) {
      let entity = this.entities.filter(entity => entity.id === flow.client_id)[0]
      return entity ? entity.name : 'N/A'
    },
    handleFlowClicked: function({row}) {
      let selectedFlow = row
      const entity = this.entities.filter(entity => entity.id === row.client_id)[0]
      selectedFlow.client = entity ? entity : null
      this.$emit('flowClicked', selectedFlow)
    }
  },
  computed: {
    entities: function () {
      let leadsWebService = this.$store.state.services.find(service => service.url === this.$store.state.leads_web_server) || null
      if (leadsWebService) {
        return leadsWebService.entities
      }
      return []
    },
  },
  watch: {
    querySearch: function (value) {
      this.$refs.leadsWebFlowsTable.setFilter(value)
    },
    customQueries: {
      handler: function (value) {
        if(value) {
          if (value.start && value.start !== '') {
            this.filters.dateRange.start = value.start
          } else {
            this.$nextTick(function () {
              this.$refs.leadsWebFlowsTable.customQueries.start = this.moment().subtract(1, 'months').format('YYYY-MM-DD')
            })
          }

          if (value.end && value.end !== '') {
            this.filters.dateRange.end = value.end
          } else {
            this.$nextTick(function () {
              this.$refs.leadsWebFlowsTable.customQueries.end = this.moment().format('YYYY-MM-DD')
            })
          }
        }
      },
      immediate: true
    },
    'filters.dateRange': function (value) {
      this.$refs.leadsWebFlowsTable.customQueries.start = value.start || ''
      this.$refs.leadsWebFlowsTable.customQueries.end = value.end || ''
      this.emitTableFilter('vue-tables.leadsWebFlowsTable.filter::end', value.end || '')
    },
  },
}
</script>

<style>
.createdAtClass {
  width: 300px;
}
</style>
<style scoped>

.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 1.375rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 1.375rem;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 5px;
  opacity: 0;
  position: absolute;
  top: 6px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #29c4a9;
  border-color: #29c4a9;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

</style>
